const isStringNullOrEmpty = (value) => {
  return !value || value.length === 0 || !value.toString().trim();
};
const getFirstCharacterInString = (value) => {
  return typeof value === "string" ? value?.charAt(0) : null;
};
export {
  getFirstCharacterInString,
  isStringNullOrEmpty
};
//# sourceMappingURL=string.js.map
